import AdmanLoggerOptions from '@/interfaces/AdmanLoggerOptions';
import {
	DwhCallback,
	SlotClickData,
	SlotInsertComplete,
	Status,
	XrayData,
} from '@/interfaces/SlotInsertComplete';
import {onComplete} from '@/logger/complete';
import {getData} from '@/logger/data';
import {onError} from '@/logger/error';
import {sendInitLog} from '@/logger/init';
import {onWindowBlurHandler} from '@/logger/mouseActions';
import {onRender} from '@/logger/render';
import hasBlocker, {hasAdBlock, hasAdBlockWhiteList} from '@/utils/adblockerDetector';
import getSlotHandlerKeeper from '@/utils/handlerKeeper';
import {getSearchUid, getSlotBlockName, getSlotData} from '@/utils/helpers';
import injector from '@/utils/injector';
import inView from '@/utils/inView';
import {getXraySendParams, sendXray, updateChain} from '@/utils/xray';

// State
let slotClickData: SlotClickData = null;
let frameMouseLeaveTimer: number = null;

function getState() {
	return {
		slotClickData,
		frameMouseLeaveTimer,
	};
}

function setState(newState) {
	({slotClickData, frameMouseLeaveTimer} = Object.assign(getState(), newState));
}

const logSlotInsertComplete = (data: SlotInsertComplete, dwhCallback?: DwhCallback) => {
	const {status} = data.result;

	const {dwh} = getData(data);

	const chain = [];

	const xray: XrayData = {
		chain,
		dwh,
	};

	if (status === Status.RENDER) {
		onRender(data, xray, {getState, setState}, dwhCallback);
	} else {
		if (status !== Status.INSERT_TIMEOUT) {
			onError(data, xray);
		}

		onComplete(data, xray);
	}

	if (chain.length) {
		sendXray(xray);
	}
};

/**
 * Главный класс
 */
export default class AdmanLogger {
	static handlerKeeper = getSlotHandlerKeeper;
	static inView = inView;
	static injector = injector;
	static getSearchUid = getSearchUid;
	static getSlotBlockName = getSlotBlockName;
	static getXraySendParams = getXraySendParams;
	static updateChain = updateChain;
	static hasAdBlock = hasAdBlock;
	static hasAdBlockWhiteList = hasAdBlockWhiteList;
	static hasBlocker = hasBlocker;

	static getSlotData(html) {
		return getSlotData({html, slot: '', banner: ''});
	}

	constructor(options: AdmanLoggerOptions) {
		const {logger, features, xray} = options;

		injector.setAll({
			logger,
			features,
			xray,
		});

		setTimeout(() => {
			sendInitLog();
		}, 2000);

		window.addEventListener('blur', () => onWindowBlurHandler(getState));
	}

	slotInsertComplete(data: SlotInsertComplete, dwhCallback?: DwhCallback) {
		logSlotInsertComplete(data, dwhCallback);
	}
}
